<template>
  <div class="main">
    <div class="title-bar">
      <h1>Create an Account</h1>
    </div>
    <div class="container py-3 py-lg-5">
      <FormWrapper :action="route('profile.accounts.store')" method="POST">

        <transition name="fade">
          <div v-if="hasAlert">
            <div v-if="validationErrors.includes('hvacp_email')" class=" alert text-center alert-danger text-left">
              <h2 class="mb-3">There was an issue creating the account account.</h2>
              <p class="text-danger">This email address is associated with an HVACPartners account.</p>
            </div>
            <div v-else class="text-center">
              <Alert :alert="alert"/>
            </div>
          </div>
        </transition>

        <div class="row">
          <div class="col-12 mb-3">
            <h3 class="text-primary">Contact Information</h3>
          </div>
          <div class="col-6">
            <Field
                :value="user.first_name"
                label="First Name"
                name="first_name"
                type="text"
                validate="required"
                validate-as="First Name"
            />
          </div>
          <div class="col-6">
            <Field
                :value="user.last_name"
                label="Last Name"
                name="last_name"
                type="text"
                validate="required"
                validate-as="Last Name"
            />
          </div>
          <div class="col-6">
            <Field
                :value="user.email"
                label="Email"
                name="email"
                type="text"
                validate="required"
                validate-as="Email"
            />
          </div>
          <div class="col-3">
            <Field :value="user.phone" label="Phone" name="phone" type="text"/>
          </div>
          <div class="col-3">
            <Field :value="user.fax" label="Fax" name="fax" type="text"/>
          </div>

          <div class="col-12 mb-3">
            <hr/>
            <h3 class="text-primary">Login Credentials</h3>
          </div>
          <div class="col-6">
            <Field
                help-text="Minimum password length: 8 characters"
                label="Password"
                name="password"
                type="password"
                value=""
            />
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <div class="buttons">
              <input
                  class="btn btn-primary mr-2"
                  name="submit"
                  type="submit"
                  value="Create Account"
              />
              <a :href="route('dashboard')" class="btn btn-secondary">Cancel</a>
            </div>
          </div>
        </div>

      </FormWrapper>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
  mixins: [DisplaysAlerts],
  props: {
    user: {type: Object},
  },
  data: () => {
    return {
      userType: "contractor",
    };
  },
  methods: {
    load() {
      this.userType = this.user.user_type;
    },
  },
  mounted() {
    this.load();
  },
};
</script>
